export const CtxFilterOptions = {
  TYPE: [
      {
          name: 'Query',
          value: 1,
      },
      {
          name: 'Cohort Intelligence',
          value: 4,
      },
      {
          name: 'Content Library',
          value: 5,
      },
      {
          name: 'Viral Library',
          value: 7,
      },
      {
          name: 'Mindset Library',
          value: 8,
      },
  ],
  ISACTIVEFILTER: [
      {
          name: 'Yes',
          value: 0,
      },
      {
          name: 'No',
          value: 1,
      },
  ],
  ISDEPRECIATED: [
      {
          name: 'Yes',
          value: 0,
      },
      {
          name: 'No',
          value: 1,
      },
  ],
};
